module.exports = __webpack_public_path__ + "static/groupingRows-58b0a748b99222deec06e19c2c5e2093.gif";